import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AccountingInvoiceSchema = withDefaults({
  type: 'accounting-invoice',
  objectExtensions: ['accounting-invoice'],
  fields: [
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'invoiceDate',
    },
    {
      kind: 'attribute',
      name: 'invoicePath',
    },
    {
      kind: 'attribute',
      name: 'invoiceType',
    },
    {
      kind: 'attribute',
      name: 'period',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'tag',
    },
    {
      kind: 'attribute',
      name: 'stats',
    },
    {
      kind: 'attribute',
      name: 'total',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'accountingPayment',
      type: 'accounting-payment',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'accountingLineItems',
      type: 'accounting-line-item',
      options: {
        async: false,
        inverse: 'accountingInvoice',
      },
    },
    {
      kind: 'hasMany',
      name: 'accountingTransactions',
      type: 'accounting-transaction',
      options: {
        async: false,
        inverse: 'accountingInvoice',
      },
    },
  ],
});

export default AccountingInvoiceSchema;
